<template>
  <section v-bind="sectionProps">
    <v-container v-bind="containerProps">
      <v-row v-bind="contentRowProps">
        <v-col v-bind="contentColumnProps">
          <div
            class="section-title"
            v-bind="titleProps"
            v-if="section.content.title"
            v-inline-editable.html="section.content.title"
          ></div>

          <div
            class="section-image"
            v-bind="imageProps"
            v-if="section.content.image"
          >
            <v-img :src="loadMedia(section.content['image'], 'md')"></v-img>
          </div>

          <div
            class="section-introtext"
            v-bind="introtextProps"
            v-if="section.content.introtext"
            v-inline-editable.html="section.content.introtext"
          ></div>

          <div
            v-if="parseBoolean(section.layout['content-box'])"
            v-bind="contentBoxProps"
          ></div>

          <content-buttons :buttons="section.content.buttons" />
        </v-col>
      </v-row>
    </v-container>

    <parallax-background-image
      v-if="section.design['background-image']"
      :section="section"
      v-bind="backgroundImageProps"
    ></parallax-background-image>

    <slot name="toolbar"></slot>
  </section>
</template>

<script>
import ContentButtons from '../../partials/buttons/ContentButtons'
import ParallaxBackgroundImage from '@/components/sections/partials/elements/ParallaxBackgroundImage'

export default {
  name: 'ContentDefaultSection',
  props: {
    section: {
      type: Object,
      required: true
    },
    templateSettings: {
      type: Object,
      required: true
    },
    builder: {
      type: Boolean,
      default: true
    }
  },
  components: {
    ParallaxBackgroundImage,
    ContentButtons
  },
  computed: {
    sectionProps() {
      let additionalStyle = {}

      if (this.parseBoolean(this.section.design['custom-padding'])) {
        additionalStyle.paddingTop = this.section.design['padding-top']
        additionalStyle.paddingBottom = this.section.design['padding-bottom']
      }

      return {
        style: {
          backgroundColor: this.section.design['background-color'],
          ...additionalStyle
        }
      }
    },
    backgroundImageProps() {
      return {
        style: {
          height: '100%',
          position: 'absolute',
          top: 0,
          bottom: 0,
          left: 0,
          right: 0
        }
      }
    },
    containerProps() {
      return {
        'fill-height': true,
        fluid: this.parseBoolean(
          this.section.layout['content-container-fluid']
        ),
        style: {
          position: 'relative',
          zIndex: 1
        }
      }
    },
    contentRowProps() {
      return {
        'no-gutters': true,
        class: [
          `justify-${this.section.layout['content-horizontal-alignment']}`,
          `text-${this.section.layout['content-justify']}`
        ]
      }
    },
    contentColumnProps() {
      let additionalProps = {}

      if (!this.parseBoolean(this.section.layout['content-container-fluid'])) {
        additionalProps = {
          ...this.calculateColumnContainerSize(
            this.section.layout['content-container-size']
          )
        }
      }

      return {
        ...additionalProps,
        style: {
          position: 'relative',
          padding: this.parseBoolean(this.section.layout['content-box'])
            ? this.section.layout['content-box-padding']
            : 0
        }
      }
    },
    titleProps() {
      return {
        is: this.section.design['title-tag'],
        style: {
          color: this.section.design['title-color'],
          fontWeight: this.section.design['title-font-weight']
        }
      }
    },
    imageProps() {
      return {
        class: 'my-6'
      }
    },
    introtextProps() {
      return {
        style: {
          color: this.section.design['introtext-color']
        }
      }
    },
    contentBoxProps() {
      let additionalClass = ['content-box']

      if (this.parseBoolean(this.section.layout['content-box-rounded'])) {
        additionalClass.push('rounded')
      }

      return {
        class: [
          `elevation-${this.section.layout['content-box-elevation']}`,
          ...additionalClass
        ],
        style: {
          position: 'absolute',
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: -1,
          backgroundColor: this.section.layout['content-box-color'],
          opacity: this.section.layout['content-box-opacity']
        }
      }
    }
  }
}
</script>
